import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from "rxjs/operators";
import { HttpServiceBase } from "../classes/HttpServiceBase";

@Injectable({
    providedIn: 'root'
})
export class BackendService extends HttpServiceBase {

    constructor(
        private http: HttpClient,
    ) {
        super();
        this.assign(this);
    }


    public getInstallation(): Observable<any> {
        console.log('Getting installation with url:', this.baseUrl + '/installation');
        return this._http.post(this.baseUrl + '/installation', { type: "web", identifier: window?.location?.hostname, systemInfo: '' })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public createOrder(data: any): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/create-order', { orderDetails: data })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getSpaceTypes(): Observable<any> {
        return this._http.get(this.baseUrl + '/space-types')
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getAutomations(): Observable<any> {
        return this._http.get(this.baseUrl + '/automations')
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getCountryFromIP(): Observable<any> {
        return this._http.post(this.baseUrl + '/get-country-from-ip', {})
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getCountryCodes(): Observable<any> {
        return this._http.post(this.baseUrl + '/phone-codes', {})
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getProjects(): Observable<any> {
        return this._http.get(this.baseUrl + '/projects')
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getOrders(latest: boolean): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/get-orders', { latest: latest })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public filterOrders(filters: any): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/filter-orders', { filters: filters })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public getOrderById(id: string): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/get-order-by-id', { orderId: id })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public takeOrder(orderId: string): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/assign-order', { orderId: orderId })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    /** The statuses an order can be set to (Wallio_OrderStatuses). */
    public getOrderStatuses(): Observable<any> {
        return this._http.get(this.baseUrl + '/orders/order-statuses')
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public updateOrderStatus(orderId: string, statusId: string): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/update-order-status', { orderId: orderId, statusId: statusId })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public addComment(orderId: string, comment: string): Observable<any> {
        return this._http.post(this.baseUrl + '/orders/add-comment', { orderId: orderId, comment: comment })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public calculateDashboardStats(): Observable<any> {
        return this._http.get(this.baseUrl + '/orders/calculate-dashboard-stats')
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public calculatePrice(size: number, spaceType: object) {
        return this._http.post(this.baseUrl + '/orders/price-calculation', { size, spaceType })
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }
}
